<template>
  <page>
    <div>
      <v-card>
        <form>
          <message :messages="messages"></message>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-lg>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-text-field
                            v-model="form.currAcctYear"
                            :label="label.currAcctYear"
                            :error-messages="errors.collect('currAcctYear')"
                            data-vv-name="currAcctYear"
                            :data-vv-as="label.currAcctYear"
                            @change="getGlYrCloseCtrl($event)"
                            :loading="loading"
                            v-validate="currAcctYearValidation"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6></v-flex>
                        <v-flex xs6>
                          <v-autocomplete
                            :items="tranferBudgets"
                            v-model="form.transferBudget"
                            :label="label.transferBudget"
                            item-text="label"
                            item-value="value"
                            data-vv-name="transferBudget"
                            :data-vv-as="label.transferBudget"
                            :error-messages="errors.collect('transferBudget')"
                            v-validate="'required'"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6></v-flex>
                        <v-flex lg12 sm12 xs12>
                          <v-text-field
                            v-model="form.branch"
                            :label="label.branch"
                            :error-messages="errors.collect('branch')"
                            data-vv-name="branch"
                            :data-vv-as="label.branch"
                            append-icon="mdi-magnify"
                            @click:append="getHelpList('branch')"
                            v-validate="'required'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg12 sm12 xs12>
                          <v-checkbox color="primary" :label="label.checkGLBal" v-model="form.checkGLBal"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <v-layout row wrap>
                      <v-flex lg12 md12 xs12>
                        <v-btn class="mr-2" color="error" dark @click.prevent="doCancel">
                          {{ label.cancel }}
                          <v-icon right dark>mdi-close-circle</v-icon>
                        </v-btn>
                        <v-btn class="mr-2" color="info" dark @click="doSchedule">
                          {{ label.schedule }}
                          <v-icon right dark>mdi-clock</v-icon>
                        </v-btn>
                        <v-btn color="primary" dark type="submit" @click.prevent="doExport">
                          {{ label.submit }}
                          <v-icon right dark>mdi-check</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </form>
        <v-dialog v-model="processingFlag" persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Processing...
              <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="helplist" width="900px" persistent>
          <helplist :apiURI="apiURI" :mode="mode" :param="param" @close="doClose" @doAssign="doAssign($event)"></helplist>
        </v-dialog>
        <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
          <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
        </v-dialog>
      </v-card>
    </div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import Helplist from '../Helplist'
import { expandURI } from '@/utils/ajax'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'

export default {
  data() {
    return {
      label: {
        transferBudget: 'Transfer Budget',
        branch: 'Branch',
        currAcctYear: 'Closing for Financial Year',
        checkGLBal: 'Check if GL is Balanced',
        submit: 'Submit',
        schedule: 'Schedule',
        cancel: 'Cancel'
      },
      form: {
        transferBudget: 'N',
        branch: 'All',
        currAcctYear: '',
        cRunProg: 'Close',
        checkGLBal: true,
        acctYearFrom: '',
        acctYearTo: ''
      },
      tranferBudgets: [
        { label: 'No', value: 'N' },
        { label: 'Original Budget', value: 'O' },
        { label: 'Revised Budget', value: 'R' }
      ],
      supportedFormat: [],
      loading: false,
      submitting: false,
      menu: {},
      helplist: false,
      apiURI: '',
      mode: '',
      param: '',
      toggleFilters: [true],
      defAcctYr: '',
      isClosed: false,
      scheduleJobModal: false,
      jobName: 'qrtzCloseFinancialYear',
      jobDesc: 'Close Financial Year',
      processingFlag: false,
      panel: [0]
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('glManagementInit')])
      await Promise.all([this.$store.dispatch('financialYearInit')])
      this.getCompany()
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      if (fieldName === 'branch') {
        this.apiURI = this.$store.state.generalLedger.financialYear.menu.branchList
        this.param = this.form.branch
      }
      this.helplist = true
    },
    doAssign(Obj) {
      switch (this.mode) {
        case 'branch':
          this.form.branch = ''
          this.form.branch = Obj.finalSelectedItems.toString()
          break
      }
    },
    doClose() {
      this.helplist = false
    },
    async getCompany() {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.getCompany
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.form.acctYearFrom = data.company.currAcctYr
          this.form.acctYearTo = data.company.currAcctYr + 1
          this.form.currAcctYear = data.company.currAcctYr
          this.defAcctYr = data.company.currAcctYr
          this.getGlYrCloseCtrl(data.company.currAcctYr)
        }
      }
    },
    async getGlYrCloseCtrl(currAcctYr) {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.getGLYrCloseCtrl
      if (apiURI) {
        this.loading = true
        const expand = {
          acctYr: currAcctYr
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.loading = false
          this.isClosed = data.glYrCloseCtrl.closed
        } else {
          this.loading = false
          this.isClosed = false
        }
      }
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.scheduleJob()
        }
      })
    },
    scheduleJob() {
      this.scheduleJobModal = true
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.getTransferBalanceList
      if (apiURI) {
        this.processingFlag = true
        try {
          this.submitting = true
          let tranBalAuditList = [{}]
          let tranBalErrorList = [{}]
          await this.$http.post(apiURI, this.form).then((result) => {
            tranBalAuditList = result.data.tranBalAuditList
            tranBalErrorList = result.data.tranBalErrorList
          })
          await this.generateXferBalAudit(tranBalAuditList)
          await this.generateXferBalError(tranBalErrorList)
          await this.getCompany()
          this.submitting = false
          this.processingFlag = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
          this.processingFlag = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async generateXferBalAudit(tranBalAuditList) {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.generateXferBalAudit
      if (apiURI) {
        try {
          if (tranBalAuditList) {
            const expand = {
              tranBalAuditList: tranBalAuditList,
              acctYearFrom: this.form.acctYearFrom,
              acctYearTo: this.form.acctYearTo
            }
            await Promise.all([this.$http.post(apiURI, expand)])
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async generateXferBalError(tranBalErrorList) {
      const apiURI = this.$store.state.generalLedger.financialYear.menu.generateXferBalError
      if (apiURI) {
        try {
          if (tranBalErrorList) {
            const expand = {
              tranBalErrorList: tranBalErrorList,
              acctYearFrom: this.form.acctYearFrom,
              acctYearTo: this.form.acctYearTo
            }
            await Promise.all([this.$http.post(apiURI, expand)])
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.$router.go(-1)
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('currAcctYearDate', {
      getMessage(field, args) {
        return 'Accounting Year must be less than Current Accounting Year'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var currAcctYear = args[0]
        if (parseInt(currAcctYear) < parseInt(value)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('isClosedDate', {
      getMessage(field, args) {
        return 'Financial Year is closed'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var closed = args[0]
        if (closed === 'true') {
          return false
        } else {
          return true
        }
      }
    })
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    currAcctYearValidation() {
      if (this.form.acctYearFrom !== '') {
        return 'entry|numeric|max:4|currAcctYearDate:' + parseInt(this.defAcctYr) + '|isClosedDate:' + this.isClosed
      } else {
        return 'required'
      }
    }
  },
  watch: {
    supportedList: function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  mixins: [MessageMixin],
  components: {
    ScheduleJob,
    Helplist
  }
}
</script>
